import { completeTypes, createTypes, withPostSuccess } from 'redux-recompose';

import { CONTRACTS_NAMES, CONTRACTS_EVENTS, CONTRACTS_FUNCTIONS } from '#models/contracts/constants';
import * as ContractsService from '#services/ContractsService';
import * as MashingsService from '#services/MashingsService';
import ModalActions from '#redux/Modal/actions';
import { MODALS } from '#redux/Modal/constants';

import { MASHINGS_TARGETS } from './constants';
import {
  mapAddedMashings,
  mapAddMashing,
  mapCreateMash,
  mapUpdatedMashings,
  mapUpdateMashing,
  mapUpdateMashStep
} from './mappers';

export const actions = createTypes(
  completeTypes({
    primaryActions: [
      'GET_ALL_ADDED_MASHINGS',
      'ADD_MASHING',
      'UPDATE_MASHING',
      'GET_ALL_UPDATED_MASHINGS',
      'CREATE_MASH',
      'GET_ALL_MASHES',
      'UPDATE_MASH_BY_ID',
      'GET_MASH_BY_ID',
      'CREATE_PRODUCTION_PROCESS'
    ],
    ignoredActions: ['SET_CURRENT_MASHING', 'SET_PRODUCTION_PROCESS_DATA']
  }),
  '@@MASHINGS'
);

export const actionCreators = {
  getAllAddedMashings: () => ({
    type: actions.GET_ALL_ADDED_MASHINGS,
    target: MASHINGS_TARGETS.ADDED_MASHINGS,
    payload: { event: CONTRACTS_EVENTS.MASHING_ADDED, contractName: CONTRACTS_NAMES.MASHING },
    service: ContractsService.getAllEvents,
    successSelector: mapAddedMashings
  }),
  addMashing: params => ({
    type: actions.ADD_MASHING,
    target: MASHINGS_TARGETS.ADD_MASHING,
    payload: {
      functionName: CONTRACTS_FUNCTIONS.ADD_MASHING,
      contractName: CONTRACTS_NAMES.MASHING,
      functionParams: mapAddMashing(params)
    },
    service: ContractsService.execFunction,
    injections: [
      withPostSuccess(dispatch => {
        dispatch(actionCreators.createMash(mapCreateMash(params)));
      })
    ]
  }),
  updateMashing: (values, id) => ({
    type: actions.UPDATE_MASHING,
    target: MASHINGS_TARGETS.UPDATE_MASHING,
    payload: {
      functionName: CONTRACTS_FUNCTIONS.UPDATE_MASHING,
      contractName: CONTRACTS_NAMES.MASHING,
      functionParams: mapUpdateMashing(values)
    },
    service: ContractsService.execFunction,
    injections: [
      withPostSuccess(dispatch => {
        dispatch(
          actionCreators.updateMashById({
            id,
            values: mapUpdateMashStep(values),
            postSuccessAction: actionCreators.getAllMashesAndCloseModal(MODALS.MASH_STEP)
          })
        );
      })
    ]
  }),
  getAllUpdatedMashings: () => ({
    type: actions.GET_ALL_UPDATED_MASHINGS,
    target: MASHINGS_TARGETS.UPDATED_MASHINGS,
    payload: { event: CONTRACTS_EVENTS.MASHING_UPDATED, contractName: CONTRACTS_NAMES.MASHING },
    service: ContractsService.getAllEvents,
    successSelector: mapUpdatedMashings
  }),
  setCurrentMash: payload => ({
    type: actions.SET_CURRENT_MASHING,
    target: MASHINGS_TARGETS.CURRENT_MASHING,
    payload
  }),
  createMash: values => ({
    type: actions.CREATE_MASH,
    target: MASHINGS_TARGETS.CREATE_MASH,
    payload: values,
    service: MashingsService.createMash,
    injections: [
      withPostSuccess(dispatch => {
        dispatch(actionCreators.getAllMashesAndCloseModal(MODALS.NEW_MASH));
      })
    ]
  }),
  getAllMashes: () => ({
    type: actions.GET_ALL_MASHES,
    target: MASHINGS_TARGETS.MASHES,
    service: MashingsService.getAllMashes
  }),
  getMashById: id => ({
    type: actions.GET_MASH_BY_ID,
    payload: id,
    target: MASHINGS_TARGETS.MASH_BY_ID,
    service: MashingsService.getMashById,
    successSelector: response => response.data.mash
  }),
  updateMashById: ({ id, values, postSuccessAction }) => ({
    type: actions.UPDATE_MASH_BY_ID,
    target: MASHINGS_TARGETS.UPDATE_MASH_BY_ID,
    payload: { id, values },
    service: MashingsService.updateMashById,
    injections: [
      withPostSuccess(dispatch => {
        if (postSuccessAction) {
          dispatch(postSuccessAction);
        }
      })
    ]
  }),
  createProductionProcess: ({ id, periodId }) => ({
    type: actions.CREATE_PRODUCTION_PROCESS,
    target: MASHINGS_TARGETS.CREATE_PRODUCTION_PROCESS,
    payload: { id, periodId },
    service: MashingsService.createProductionProcess,
    injections: [
      withPostSuccess(dispatch => {
        dispatch(actionCreators.clearPPDataAndCloseModal());
      })
    ]
  }),
  setProductionProcessData: payload => ({
    type: actions.SET_PRODUCTION_PROCESS_DATA,
    target: MASHINGS_TARGETS.PRODUCTION_PROCESS_DATA,
    payload
  }),
  getAllMashesAndCloseModal: modal => dispatch => {
    dispatch(actionCreators.getAllMashes());
    dispatch(ModalActions.closeModal(modal));
  },
  clearPPDataAndCloseModal: () => dispatch => {
    dispatch(actionCreators.setProductionProcessData({}));
    dispatch(ModalActions.closeModal(MODALS.CREATE_PRODUCTION_PROCESS));
  }
};

export default actionCreators;
